import { State } from 'src/redux/state.types';
import { DomainObject } from 'src/utils/types';

export const getActiveDomainObject = (state: State): DomainObject | null => {
    return state.domainObject.activeDomainObject;
};
